import { useFocusEffect, useNavigation } from 'expo-router';
import { useCallback, useLayoutEffect } from 'react';
import { ActivityIndicator, FlatList, StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { useGetNotificationFeed } from '@/api/hooks/notificationsHooks';
import { bell } from '@/assets/images';
import GoBackButton from '@/components/buttons/GoBackButton';
import DotsLoader from '@/components/DotsLoader';
import ListEmptyComponent from '@/components/ListEmptyComponent';
import NotificationItem from '@/components/notifications/NotificationItem';
import Title from '@/components/Title';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';
import { i18n } from '@/utils/i18n';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const Notifications = () => {
  const { bottom } = useSafeAreaInsets();
  const navigation = useNavigation();

  const { data, isPending, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage, refetch, isRefetching } =
    useGetNotificationFeed({
      limit: 10,
      markAsRead: true
    });

  const notifications = data?.pages.flatMap((page) => page.results);

  //Locales
  const title = i18n.t('profile.notifications.title');
  const empty_notifications = i18n.t('profile.notifications.empty_notifications');

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <Title label={title} />,
      headerLeft: () => <GoBackButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useFocusEffect(
    useCallback(() => {
      refetch();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  );

  return (
    <View style={styles.container}>
      {isPending ? (
        <DotsLoader />
      ) : (
        <FlatList
          data={notifications}
          scrollEnabled={true}
          keyExtractor={(item) => item.id}
          onEndReachedThreshold={0.2}
          onEndReached={(_) => {
            hasNextPage && !isFetching && fetchNextPage();
          }}
          onRefresh={refetch}
          refreshing={isRefetching}
          renderItem={({ item }) => (
            <NotificationItem
              image={
                item.thumbnail !== undefined && item.thumbnail !== null && item.thumbnail !== 'null'
                  ? firebaseImage(safeJsonParseArray(item.thumbnail)?.at(0) ?? '[]')
                  : bell
              }
              title={item.title}
              message={item.message}
              date={item.createdAt}
              readed={item.hasBeenRead}
              path={item.path}
              roomData={item.roomData}
            />
          )}
          style={styles.notificationsList}
          contentContainerStyle={styles.notificationsListContent}
          ItemSeparatorComponent={() => <Divider style={styles.divider} />}
          ListEmptyComponent={<ListEmptyComponent label={empty_notifications} />}
          ListFooterComponent={isFetchingNextPage ? <ActivityIndicator /> : <></>}
          ListFooterComponentStyle={{ paddingBottom: bottom }}
        />
      )}
    </View>
  );
};

export default Notifications;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 25
  },

  divider: {
    marginVertical: 15
  },

  notificationsList: {
    width: '100%'
  },

  notificationsListContent: {
    paddingHorizontal: 18
  }
});
